import React from 'react';
import { getMetricDisplayName } from '../../config/metrics';

interface MetricDisplayProps {
  metricKey: string;
  score: number;
  compact?: boolean;
}

const MetricDisplay: React.FC<MetricDisplayProps> = ({ metricKey, score, compact = false }) => {
  const getScoreColor = (score: number): string => {
    if (score >= 7) return '#22c55e';   // Green for 7-10
    if (score >= 5) return '#f59e0b';   // Amber for 5-6.9
    if (score >= 3) return '#ef4444';   // Red for 3-4.9
    return '#6b7280';                   // Gray for 1-2.9
  };

  if (compact) {
    return (
      <div style={{ textAlign: 'center', minWidth: '80px' }}>
        <div style={{ 
          fontSize: '18px', 
          fontWeight: 'bold', 
          color: getScoreColor(score),
          marginBottom: '4px'
        }}>
          {score}
        </div>
        <div style={{ fontSize: '12px', color: '#6b7280', lineHeight: '1.2' }}>
          {getMetricDisplayName(metricKey)}
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      marginBottom: '8px' 
    }}>
      <h5 style={{ fontWeight: '500', color: '#374151', margin: 0 }}>
        {getMetricDisplayName(metricKey)}
      </h5>
      <span style={{ fontSize: '18px', fontWeight: 'bold', color: getScoreColor(score) }}>
        {score}
      </span>
    </div>
  );
};

export default MetricDisplay;